function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconWheelChair = function IconWheelChair(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "77",
    height: "100",
    viewBox: "0 0 77 100",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3728_10728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5766 20.5613C30.5679 20.5613 34.6142 16.5059 34.6142 11.5033C34.6142 6.5007 30.5679 2.44531 25.5766 2.44531C20.5853 2.44531 16.5391 6.5007 16.5391 11.5033C16.5391 16.5059 20.5853 20.5613 25.5766 20.5613Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5762 27.3555V54.5294C25.5762 60.7794 30.6372 65.8518 36.8731 65.8518H59.467L75.2827 88.4968",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5762 45.4707H48.1701",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8391 48.415C7.52458 52.7629 1.85352 61.4812 1.85352 71.5129C1.85352 85.8924 13.4894 97.5545 27.8365 97.5545C42.1836 97.5545 53.8195 85.8924 53.8195 71.5129C53.8195 69.5654 53.6161 67.6632 53.2094 65.8516",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3728_10728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "77",
    height: "100",
    fill: "white"
  }))));
};